module.exports = __webpack_public_path__ + "media/images/application/favicon/logo-377d0316945f34f732b56414ebd4837e.png";